<div class="wrap" style="margin-bottom: 70px;">
  <div class="panel">
    <ul class="list" *ngFor="let notification of notifications; let i = index">
      <li class="card cart-summary" [class.offer]="notification.notification_type == 0">
        @if(notification.notification_type != 0){
        <img class="profile-icon" src="/assets/e-commerce/icons/55.webp">
        }
        @else{ <img class="profile-icon" src="/assets/e-commerce/icons/66.webp">
        }
        <div class="txt">
          @if(isAr){
          <div class="title"> {{notification.notification_head_ar}}</div>
          }
          @else{
          <div class="title"> {{notification.notification_head_en}}</div>
          }
          @if(isAr){
          <div class="sub"> {{notification.notification_body_ar}}</div>
          }
          @else{
          <div class="sub">{{notification.notification_body_en}} </div>
          }

        </div>
      </li>
    </ul>
  </div>
</div>